import type { Justificativa } from './linha.interface'

type Dispensa = Justificativa & { typeId: 'justify' }

export interface LinhaComDispensas {
  justify?: Justificativa | boolean | null
}

const ehDispensa = (
  valor: Justificativa | boolean | null | undefined,
): valor is Dispensa => {
  if (!valor || typeof valor !== 'object') return false

  return valor.typeId === 'justify'
}

export const obterDispensasDaLinha = (linha: LinhaComDispensas): ReadonlyArray<Dispensa> => {
  const justificativaPrincipal = ehDispensa(linha.justify) ? linha.justify : null
  const dispensasExtras = Array.isArray(justificativaPrincipal?.dispensasExtras)
    ? justificativaPrincipal.dispensasExtras
    : []

  return [justificativaPrincipal, ...dispensasExtras].filter(ehDispensa)
}

export const obterDispensasDaLinhaPriorizandoJustificativaAtualizada = (
  linha: LinhaComDispensas,
  justificativaAtualizada: Justificativa | null | undefined,
): ReadonlyArray<Dispensa> => obterDispensasDaLinha({
  justify: ehDispensa(justificativaAtualizada) ? justificativaAtualizada : linha.justify,
})

export const linhaPossuiDispensaDeDiaInteiro = (linha: LinhaComDispensas): boolean =>
  obterDispensasDaLinha(linha).some(dispensa => dispensa.allDay === true)

export const linhaPermiteAdicionarDispensaParcial = (linha: LinhaComDispensas): boolean => {
  if (!linha.justify) return true

  const dispensas = obterDispensasDaLinha(linha)

  return dispensas.length > 0 && dispensas.every(dispensa => dispensa.allDay === false)
}
